<template>
  <div :class="classes" :style="cssVars" v-html="svg"></div>
</template>

<script setup>
import { computed } from 'vue';

// Import all SVGs as raw strings using Vite's glob import
const svgModules = import.meta.glob('../images/*.svg', { eager: true, query: '?raw', import: 'default' });

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  classes: {
    type: String,
    required: false,
  },
  width: {
    type: String,
    required: false,
  },
  height: {
    type: String,
    required: false,
  },
  fillColor: {
    type: String,
    required: false,
  },
  strokeColor: {
    type: String,
    required: false,
  },
  borderRadius: {
    type: String,
    required: false,
    default: '4px',
  },
});

// Get the SVG content from the pre-loaded modules
const svgPath = `../images/${props.icon}.svg`;
const svg = svgModules[svgPath] || '';

const cssVars = computed(() => ({
  '--width': props.width,
  '--height': props.height,
  '--fill': props.fillColor,
  '--stroke': props.strokeColor,
  '--border-radius': props.borderRadius,
}));
</script>

<style lang="scss" scoped>
div {
  border-radius: var(--border-radius);
}
div :deep(svg) {
  width: var(--width);
  height: var(--height);
  fill: var(--fill);
  stroke: var(--stroke);
}
</style>
